import { CommonModule } from '@angular/common'
import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit, ViewEncapsulation } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar'
import { Router } from '@angular/router'
import { Subject, takeUntil } from 'rxjs'
import { AngularMaterialsModules } from 'src/app/module/materials.module'
import { QuizService } from 'src/app/service/data/quiz.service'
import { UserService } from 'src/app/service/user-info/user.service'
import { DdcQuizListComponent } from '../../shared/ddc/ddc-quiz-list/ddc-quiz-list.component'
import { SimpleQuiz } from '../../shared/models/main/quiz'

@Component({
  selector: 'app-quizzes-page',
  templateUrl: './quizzes-page.component.html',
  styleUrls: ['./quizzes-page.component.scss'],
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  imports: [
    AngularMaterialsModules,
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatSnackBarModule,
    DdcQuizListComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class QuizzesPageComponent implements OnInit {
  quizzes: SimpleQuiz[] = []
  loading = false
  loadingMore = false
  hasMore = false
  page = 1
  error: string | null = null
  private _username: string = undefined
  private destroy$ = new Subject<void>()

  constructor(
    private snackBar: MatSnackBar,
    private router: Router,
    private quizService: QuizService,
    private user_info: UserService,
  ) {}

  ngOnInit(): void {
    this.user_info.userInfo$.pipe(takeUntil(this.destroy$)).subscribe((userInfo: any) => {
      this._username = userInfo.username
    })
    this.loadQuizzes()
  }

  async loadQuizzes(): Promise<void> {
    if (this.loading) return

    try {
      if (this.page === 1) {
        this.loading = true
        this.error = null
      } else {
        this.loadingMore = true
      }

      const response = await this.quizService
        .get_quizzes_page(this._username, this.page, 10)
        .toPromise()
      console.log('QuizzesPageComponent: loadQuizzes response:', response)
      if (response && Array.isArray(response.results)) {
        const newQuizzes = response.results as SimpleQuiz[]

        if (this.page === 1) {
          this.quizzes = newQuizzes
        } else {
          // Avoid duplicates
          const existingIds = new Set(this.quizzes.map(q => q.id))
          const uniqueNew = newQuizzes.filter(q => !existingIds.has(q.id))
          this.quizzes = [...this.quizzes, ...uniqueNew]
        }

        this.hasMore = newQuizzes.length === 10
        this.page++
      } else {
        this.quizzes = []
        this.hasMore = false
      }
    } catch (error) {
      this.error = 'Failed to load quizzes. Please try again.'
      this.snackBar.open('Failed to load quizzes', 'Dismiss', {
        duration: 5000,
      })
    } finally {
      this.loading = false
      this.loadingMore = false
    }
  }

  onQuizClick(quizId: number): void {
    this.router.navigate(['/quiz', quizId])
  }

  onLoadMore(): void {
    this.loadQuizzes()
  }
}
